module.exports = __webpack_public_path__ + "img/configuration.54004410.webp";